import axios from 'axios'

const ApprovalService = {
  async get (params = {}) {
    return axios.get('scm/inter-warehouse-transfer/request-approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('scm/reports/inter-warehouse-transfer/approval-histories', { params })
  },

  async show (id) {
    return axios.get(`scm/inter-warehouse-transfer/request-approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('scm/inter-warehouse-transfer/request-approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`scm/inter-warehouse-transfer/request-approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`scm/inter-warehouse-transfer/request-approvals/${data.id}`, { data })
  }
}

export default ApprovalService
